import { NCOnboardingAnalyticsEvents, useNCWOnboardingRoutes } from '@capsicum/features/nc-onboarding/shared';
import React, { useEffect } from 'react';

import { RecoveryKitGenerated } from '../../ui';

interface NcRegistrationRecoveryKitProps {
	code: string;
	keyId: string;
	onAccept: () => void;
}

export const NcRegistrationRecoveryKit = ({ code, keyId, onAccept }: NcRegistrationRecoveryKitProps) => {
	const { triggerAnalyticsEvent } = useNCWOnboardingRoutes({});

	useEffect(() => {
		triggerAnalyticsEvent(NCOnboardingAnalyticsEvents.LAND_ON_RECOVERY_KIT);
	}, [triggerAnalyticsEvent]);

	return (
		<RecoveryKitGenerated
			code={code}
			isReplacementKitAfterRecovery={false}
			keyId={keyId}
			testIDPrefix="ncOnboarding"
			onAccept={onAccept}
		/>
	);
};
